import { ReviewSubjectType } from "@/api/cle-api";
import { CourseCertificateReviewView } from "@/components/pages/person/id/Efteruddannelse/CourseCertificateReviewView";
import { AuthorshipReviewView } from "@/components/pages/efteruddannelse/AuthorshipReviewView";
import { DispensationReviewView } from "@/components/pages/efteruddannelse/DispensationReviewView";
import { InsurancePolicyReviewView } from "@/components/pages/efteruddannelse/InsurancePolicyReviewView";
import { LegalAidReviewView } from "@/components/pages/efteruddannelse/LegalAidReviewView";
import { ReductionReviewView } from "@/components/pages/efteruddannelse/ReductionReviewView";
import { TeachingReviewView } from "@/components/pages/efteruddannelse/TeachingReviewView";
import { isReviewSubjectType } from "@/components/pages/efteruddannelse/utils/reviewThreadNavigation";
import Button from "@/components/bricks/button/Button";
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon";
import PageTitle from "@/components/PageTitle";
import type { ReactNode } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ReviewThreadDetail = () => {
  const navigate = useNavigate();
  const { subjectType, ownerUserId, subjectId } = useParams<{
    subjectType: string;
    ownerUserId: string;
    subjectId: string;
  }>();

  const handleBack = () => navigate("/efteruddannelse");

  if (!subjectType || !ownerUserId || !subjectId) {
    return (
      <div className="container py-4">
        <p className="text-danger">Ugyldig henvendelse.</p>
        <Button
          color="secondary"
          transparent
          type="button"
          onClick={handleBack}
        >
          <ChevronLeftIcon />
          Tilbage til efteruddannelse
        </Button>
      </div>
    );
  }

  if (!isReviewSubjectType(subjectType)) {
    return (
      <div className="container py-4">
        <p className="text-danger">Ukendt emnetype: {subjectType}</p>
        <Button
          color="secondary"
          transparent
          type="button"
          onClick={handleBack}
        >
          <ChevronLeftIcon />
          Tilbage til efteruddannelse
        </Button>
      </div>
    );
  }

  let content: ReactNode;

  switch (subjectType) {
    case ReviewSubjectType.COURSE_CERTIFICATE:
      content = (
        <CourseCertificateReviewView
          userId={ownerUserId}
          evidenceId={subjectId}
          onBack={handleBack}
        />
      );
      break;
    case ReviewSubjectType.TEACHING:
      content = (
        <TeachingReviewView
          userId={ownerUserId}
          teachingId={subjectId}
          onBack={handleBack}
        />
      );
      break;
    case ReviewSubjectType.REDUCTION:
      content = (
        <ReductionReviewView
          userId={ownerUserId}
          onBack={handleBack}
          reductionId={subjectId}
        />
      );
      break;
    case ReviewSubjectType.LEGAL_AID:
      content = (
        <LegalAidReviewView
          userId={ownerUserId}
          onBack={handleBack}
          legalAidId={subjectId}
        />
      );
      break;
    case ReviewSubjectType.AUTHORSHIP:
      content = (
        <AuthorshipReviewView
          userId={ownerUserId}
          authorshipId={subjectId}
          onBack={handleBack}
        />
      );
      break;
    case ReviewSubjectType.INSURANCE_POLICY:
      content = (
        <InsurancePolicyReviewView
          userId={ownerUserId}
          insurancePolicyId={subjectId}
          onBack={handleBack}
        />
      );
      break;
    case ReviewSubjectType.DISPENSATION:
      content = (
        <DispensationReviewView
          userId={ownerUserId}
          dispensationId={subjectId}
          onBack={handleBack}
        />
      );
      break;
    default:
      content = null;
  }

  return (
    <div className="overflow-auto">
      <PageTitle title="Henvendelse" />
      {content}
    </div>
  );
};

export default ReviewThreadDetail;
